import React, { memo, useCallback } from 'react'
import block from 'bem-cn'

import { useLoading } from './model/useLoading'

import './LoadableImage.scss'

export interface ILoadableImageProps {
  src: string
  alt?: string
  onLoad?: (image: HTMLImageElement) => void
  onError?: () => void
  className?: string
  classNameContainer?: string
  hidden?: boolean
  animationType?: 'smallToBig' | 'slide' | 'appearance' | 'default'
  isWithCrossOrigin?: boolean
}

const b = block('loadable-image')

export const LoadableImageComponent: React.FC<ILoadableImageProps> = props => {
  const {
    src,
    alt = '',
    onLoad = () => {},
    onError = () => {},
    hidden = false,
    className = '',
    classNameContainer = '',
    animationType = 'default',
    isWithCrossOrigin = false,
  } = props

  const { currentSrc, isLoaded, imageRef, containerRef, isVisible, setIsLoaded } = useLoading({ src, onLoad })

  const _onError = useCallback(() => {
    setIsLoaded(true)
    onError()
  }, [onError, setIsLoaded])

  return (
    <div
      ref={containerRef}
      className={b('container', {
        loaded: isLoaded,
        forwardAnimationType: isLoaded ? animationType : null,
        backwardAnimationType: !isLoaded ? animationType : null,
      }).mix(classNameContainer)}>
        <img
          onError={_onError}
          ref={imageRef}
          className={b('image', {
            loaded: isLoaded,
            isVisible,
            hidden,
          }).mix(className)}
          src={currentSrc}
          alt={alt}
          {...(isWithCrossOrigin ? { crossOrigin: 'anonymous' } : {})}
        />
    </div>
  )
}

export const LoadableImage = memo(LoadableImageComponent)
